'use strict';
import React, { Component } from 'react';
import {View, Text, Image, TouchableWithoutFeedback, Animated} from 'react-native';

import { observer, inject } from 'mobx-react';
import {autorun} from 'mobx';

import Constraints from '../../../../constaints/index';
import QImageSet from '../../../../../../assets/QImageSet';

import styles from './style';
import {getScreenSize} from "../../../../../../common/utils";

const SLIDER_LEFT = -50;


@inject(stores => {
    const {searchDataStore, lowPriceDataStore} = stores,
        {flightType, handleSelectFlightType, windowWidth} = searchDataStore,
        {fixedSearchBoxVisible} = lowPriceDataStore;
    return {
        flightType,
        windowWidth,
        handleSelectFlightType,
        fixedSearchBoxVisible
    };
})

@observer
class FlightType extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sliderLeft: new Animated.Value(SLIDER_LEFT)
        };

        autorun(() => {
            this.sliderToLeft(this.props.flightType);
        })

    }
    sliderToLeft = (flightType) => {
        let sliderRight = this.props.windowWidth/ 2 - 36;
        let toValue = flightType === 1 ? SLIDER_LEFT : sliderRight;
        Animated.timing(this.state.sliderLeft, {
            toValue: toValue,
            duration: 300
        }).start();
    };


    chooseFlightType = (item) => {
        GodEye.log({
            r: 'searchbox_switch_click',
            switch: item.flightType === Constraints.flightType.oneway ? 'oneway' : 'roundtrip'
        })
        this.props.handleSelectFlightType(item)
    };

    render() {
        const {oneway, roundtrip} =  Constraints.flightType || {};
        const renderData = [
            {text: '单程', flightType: oneway},
            {text: '往返', flightType: roundtrip}
        ];

        return (
            <View style={[styles.searchFlightType, this.props.fixedSearchBoxVisible ? {backgroundColor: 'rgba(241,242,245,1)'} :{}]}>
                <View style={[styles.searchFlightTypeContainer]}>
                    <Animated.View style={[styles.searchFlightTypeTab, {left: this.state.sliderLeft}]}>
                        <Image source={{uri: QImageSet.tabLeft}} style={styles.searchLeft}/>
                        <View style={[styles.searchMiddle, {width: (this.props.windowWidth / 2 - 8) - 30}]}/>
                        <Image source={{uri: QImageSet.tabRight}} style={styles.searchRight}/>
                    </Animated.View>

                    {renderData.map((item) => {
                        const {text} = item || {};
                        return  <TouchableWithoutFeedback style={styles.searchFlightTypeItem} onPress={()=>{this.chooseFlightType(item)}} key={text}>
                            <Text style={[
                                styles.searchFlightTypeText,
                                this.props.flightType === item.flightType ? styles.activeFlightType : {}
                            ]}>{text}</Text>
                        </TouchableWithoutFeedback>
                    })}
                </View>
            </View>
        )
    }
}

export default FlightType;
